import { render, staticRenderFns } from "./WorkflowsEdit.vue?vue&type=template&id=490dc2dd"
import script from "./WorkflowsEdit.vue?vue&type=script&lang=js"
export * from "./WorkflowsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports